<agpr-popup-dialog
    id="AIRefinementDialog"
    class="agpr-aiRefinementDialog"
    [positionX]="positionX"
    [positionY]="positionY"
    (click)="cancel()"
    (close)="cancel()"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div
        (click)="setSelf($event)"
        class="agpr-aiRefinementDialog-content"
    >
        <agpr-ai-prompt-suggestion
            [prompt]="prompt"
            (submitPrompt)="submitRefinementPrompt($event)"
        >
        </agpr-ai-prompt-suggestion>
    </div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
</agpr-popup-dialog>
